//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SUPERVISORS from '@/constants/supervisor'
import ModalAssignedCollaborators from './ModalAssignedCollaborators.vue'
import ModalRemoveSupervisor from './ModalRemoveSupervisor.vue'
import ModalRemoveSupervisorWithCollaborators from './ModalRemoveSupervisorWithCollaborators.vue'
import ModalAssignSupervisors from './ModalAssignSupervisors.vue'
import PROJECT_VALIDATION_STATUS from '~/constants/project-validation-status'

export default {
  name: 'SupervisorsList',
  components: {
    ModalAssignedCollaborators,
    ModalRemoveSupervisor,
    ModalRemoveSupervisorWithCollaborators,
    ModalAssignSupervisors,
  },
  props: {
    filter: {
      default: '',
      type: String,
    },
    filterByInvitation: {
      default: null,
      type: Number || null,
    },
    supervisors: {
      default: () => [],
      type: Array,
    },
    allRowschecked: {
      default: () => null,
      type: Boolean,
    },
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      invitationStatus: SUPERVISORS.INVITATION_STATUS,
      checkedRows: [],
      paginationSize: 6,
      currentPage: 1,
      actions: [
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.validationReminder'
          ),
          key: 'validationReminder',
        },
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.resendInvitation'
          ),
          key: 'resendInvitation',
        },
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.viewCollaborators'
          ),
          key: 'viewCollaborators',
        },
        {
          label: this.$t(
            'projects.detail.supervisors.table.actionItems.removeFromProject'
          ),
          key: 'removeFromProject',
        },
      ],
      isAssignedCollaboratorsVisible: false,
      collaborators: [],
      isModalRemoveSupervisorVisible: false,
      isModalRemoveSupervisorWithCollaboratorsVisible: false,
      isModalAssignSupervisorsVisible: false,
      removeSupervisorData: {},
      unassignedCollaborators: [],
      removedSupervisor: {},
      supervisorsOptions: [],
    }
  },
  computed: {
    filteredSupervisors() {
      const searchText = this.filter ? this.filter.trim().toLowerCase() : null
      const selectedInvitation = this.filterByInvitation

      if (!searchText && selectedInvitation === null) {
        return this.supervisors
      }

      return this.supervisors.filter((supervisor) => {
        let matchesSearchText = false
        if (searchText) {
          const name = (supervisor.names || '').toLowerCase()
          const lastname = (supervisor.lastnames || '').toLowerCase()
          const email = (supervisor.email || '').toLowerCase()

          matchesSearchText =
            name.includes(searchText) ||
            lastname.includes(searchText) ||
            email.includes(searchText)
        }

        let matchesSelectedInvitation = false
        if (selectedInvitation !== null) {
          matchesSelectedInvitation =
            supervisor.invitation_active === selectedInvitation
        }

        if (searchText && selectedInvitation !== null) {
          return matchesSearchText && matchesSelectedInvitation
        } else if (searchText) {
          return matchesSearchText
        } else if (selectedInvitation !== null) {
          return matchesSelectedInvitation
        }
        return false
      })
    },
  },
  watch: {
    allRowschecked() {
      this.toggleCheckVisibleRows()
    },
  },
  methods: {
    availableItems(row) {
      return this.actions.filter((item) => {
        switch (item.key) {
          case 'validationReminder':
            return this.validationReminderAvailability(row)
          case 'resendInvitation':
            return this.resendInvitationAvailability(row)
          default:
            return true
        }
      })
    },
    validationReminderAvailability(row) {
      return (
        row.collaborators.length > 0 &&
        !row.invitation_active &&
        row.progress < 100
      )
    },
    resendInvitationAvailability(row) {
      return row.invitation_active
    },
    getClassByStatus(isActive) {
      if (isActive) {
        return SUPERVISORS.INVITATION_STATUS.ACTIVE.class
      }
      return SUPERVISORS.INVITATION_STATUS.INACTIVE.class
    },
    getNameByStatus(isActive) {
      if (isActive) {
        return SUPERVISORS.INVITATION_STATUS.ACTIVE.name
      }
      return SUPERVISORS.INVITATION_STATUS.INACTIVE.name
    },
    isAllCheck(checkedList) {
      const checkeableVisibles = this.getCurrentPageCheckeableRows()
      if (checkeableVisibles.every((cv) => checkedList.includes(cv))) {
        this.$emit('is-all-checked', true)
      } else {
        this.$emit('is-all-checked', false)
      }
    },
    onCheck(checkedList) {
      this.$emit('checked-rows', checkedList)
      this.isAllCheck(checkedList)
    },
    pageChanged(page) {
      this.currentPage = page
      this.isAllCheck(this.checkedRows)
    },
    sortChanged() {
      this.isAllCheck(this.checkedRows)
    },
    getCurrentPageCheckeableRows() {
      const start = (this.currentPage - 1) * this.paginationSize
      const end = start + this.paginationSize
      return this.supervisors
        .slice(start, end)
        .filter(
          (row) =>
            row.invitation_active === SUPERVISORS.INVITATION_STATUS.ACTIVE.value
        )
    },
    toggleCheckVisibleRows() {
      const checkeableVisibles = this.getCurrentPageCheckeableRows()
      const allSelected = checkeableVisibles.every((row) =>
        this.checkedRows.includes(row)
      )

      if (allSelected) {
        this.checkedRows = this.checkedRows.filter(
          (row) => !checkeableVisibles.includes(row)
        )
      } else {
        const newChecked = [
          ...this.checkedRows,
          ...checkeableVisibles.filter(
            (row) => !this.checkedRows.includes(row)
          ),
        ]
        this.checkedRows = newChecked
      }
      this.onCheck(this.checkedRows)
    },
    toggleAssignedCollaboratorsModal() {
      this.isAssignedCollaboratorsVisible = !this.isAssignedCollaboratorsVisible
    },
    getAssignedCollaboratorsModalClose(isClose) {
      if (isClose) this.toggleAssignedCollaboratorsModal()
    },
    viewCollaboratorsAction(row) {
      this.collaborators = row.collaborators.map((col) => {
        return { name: `${col.names} ${col.lastnames}` }
      })
      this.toggleAssignedCollaboratorsModal()
    },
    async resendInvitationAction(row) {
      return await this.$repository.invitation.sendSupervisorInvitations({
        project_id: this.project.id,
        custom_message: null,
        supervisors_ids: [row.user],
      })
    },
    async validationReminderAction(row) {
      return await this.$repository.invitation.toSupervisorsReminder({
        supervisor_id: row.user,
      })
    },
    removeFromProjectAction(row) {
      const supervisor = {
        name: `${row.names} ${row.lastnames}`,
        id: row.user,
      }
      if (row.collaborators.length === 0) {
        this.removeSupervisorData = supervisor
        this.toggleModalRemoveSupervisor()
      } else {
        supervisor.collaborators = row.collaborators.map((col) => {
          return {
            name: `${col.names} ${col.lastnames}`,
            id: col.id,
          }
        })
        this.removeSupervisorData = supervisor
        this.toggleModalRemoveSupervisorWithCollaborators()
      }
    },
    onItemAction(key, row) {
      switch (key) {
        case 'viewCollaborators':
          this.viewCollaboratorsAction(row)
          break
        case 'resendInvitation':
          this.resendInvitationAction(row)
          break
        case 'validationReminder':
          this.validationReminderAction(row)
          break
        case 'removeFromProject':
          this.removeFromProjectAction(row)
          break
      }
    },
    goToCollaborators() {
      this.toggleAssignedCollaboratorsModal()
      this.$emit('go-to-collaborators')
    },
    toggleModalRemoveSupervisor() {
      this.isModalRemoveSupervisorVisible = !this.isModalRemoveSupervisorVisible
    },
    toggleModalRemoveSupervisorWithCollaborators() {
      this.isModalRemoveSupervisorWithCollaboratorsVisible = !this
        .isModalRemoveSupervisorWithCollaboratorsVisible
    },
    toggleModalAssignSupervisors() {
      this.isModalAssignSupervisorsVisible = !this
        .isModalAssignSupervisorsVisible
    },
    async removeSupervisor(supervisorId) {
      this.$store.commit('loading', true)
      try {
        await this.$repository.user.removeSupervisorFromProject({
          project: this.project.id,
          supervisor: supervisorId,
        })
        this.$store.commit('loading', false)
        this.$emit('supervisor-removed')
        this.$buefy.notification.open({
          message: `<p style="margin-top: 10px">${this.$t(
            'projects.detail.supervisors.notifications.removeSupervisor'
          )}</p>`,
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
      } catch (e) {
        this.$store.commit('loading', false)
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
      }
      this.toggleModalRemoveSupervisor()
    },
    getCollaboratorsToAssignment(supervisor) {
      this.toggleModalRemoveSupervisorWithCollaborators()
      this.unassignedCollaborators = supervisor.collaborators
      this.removedSupervisor = supervisor
      this.supervisorsOptions = this.supervisors.filter(
        (sv) => sv.user !== supervisor.id
      )
      this.toggleModalAssignSupervisors()
    },
    async removeSupervisorWithCollaborators() {
      const supervisor = this.removedSupervisor
      this.$store.commit('loading', true)
      try {
        await this.$repository.user.removeSupervisorFromProject({
          project: this.project.id,
          supervisor: supervisor.id,
        })
        this.$store.commit('loading', false)
        this.$emit('supervisor-removed')
        this.$buefy.notification.open({
          message: `<p style="margin-top: 10px">${this.$t(
            'projects.detail.supervisors.notifications.removeSupervisor'
          )}</p>`,
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
      } catch (e) {
        this.$store.commit('loading', false)
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
      }
      this.removedSupervisor = {}
    },
    onAssignLater(collaborators) {
      this.toggleModalAssignSupervisors()
      this.$emit('assign-collaborators-later', collaborators)
    },
    async onAssignCollaborators(supervisorsAssigned) {
      this.$store.commit('loading', true)

      try {
        await supervisorsAssigned.forEach(async (sv) => {
          await this.$repository.supervisorAssignments.saveMassiveCollaborators(
            {
              collaboratorsIds: sv.collaboratorsId,
              supervisorId: sv.supervisorId,
              projectId: this.project.id,
              validationStatus: PROJECT_VALIDATION_STATUS.PENDING,
              sendInvitationEmail: true,
            }
          )
        })
        await this.removeSupervisorWithCollaborators()
        const newSupervisorIds = [
          ...new Set(supervisorsAssigned.map((sv) => sv.supervisorId)),
        ]
        await Promise.all(
          newSupervisorIds.map((supervisorId) =>
            this.$repository.projectRoles.updateValidationStatus(
              this.project.id,
              supervisorId,
              true
            )
          )
        )
        this.$store.commit('loading', false)
      } catch (e) {
        this.$store.commit('loading', false)
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
      }
      this.toggleModalAssignSupervisors()
    },
  },
}
